const getBackendUrl = () => {
    if (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
        return "http://localhost:8000";
    }
    return typeof window !== 'undefined' ? window.location.origin : "http://localhost:8000";
};

const backendUrl = `${getBackendUrl()}/api`;
export const imageBaseUrl = getBackendUrl();

export default backendUrl;